import { useAuth } from '../auth/AuthContext'
import { livelloRotta } from '../auth/permessi'
import { t } from '../i18n/lingua'

/**
 * «Posso scrivere?» per i moduli DNS e IPAM.
 *
 * La scrittura si accende **nella credenziale** della connessione («Consenti la
 * scrittura», campo `write_enabled`), non nella pagina del modulo: con due DNS
 * si può scrivere sul laboratorio e lasciare la produzione in sola lettura.
 * Con la connessione abilitata scrive chi opera sul modulo (operatore o
 * amministratore; nei ruoli personalizzati «Scrittura» sul modulo). Il Control
 * Plane lo controlla comunque — qui si decide solo cosa mostrare. Vedi
 * control-plane/app/services/scrittura_moduli.py.
 */
export function useScrittura(modulo: 'dns' | 'ipam', connessioneAbilitata: boolean | undefined) {
  const { principal } = useAuth()
  const ruoli = principal?.roles ?? []
  const opera = ruoli.some((r) => ['tenant_admin', 'tenant_operator', 'provider_admin'].includes(r))
  const livello = livelloRotta(principal?.permissions, `/${modulo}`)
  const puoOperare = opera && livello !== 'read'
  return {
    attiva: Boolean(connessioneAbilitata),
    puoScrivere: Boolean(connessioneAbilitata) && puoOperare,
    // A chi potrebbe scrivere ma la connessione non lo consente, si dice dove
    // si accende: senza, i pulsanti mancano e non si sa perché.
    spentaQui: !connessioneAbilitata && puoOperare,
  }
}

/** La riga che dice dove si accende la scrittura, quando la connessione non la consente. */
export function ScritturaSpenta() {
  return (
    <p className="field__hint">
      {t('Questa connessione è in sola lettura: la scrittura si accende nella sua credenziale, in «Connessioni» → «Consenti la scrittura».')}
    </p>
  )
}
